module.exports = __webpack_public_path__ + "img/cards.5da69d91.png";